module.exports = __webpack_public_path__ + "static/media/App_store_symbol.9a600702.png";